import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'
import type { AxiosResponse } from 'axios'
import type { ExclusionReasonResponse, TODO } from '@/types'
export default {
  provinces(): Promise<AxiosResponse<TODO>> {
    return http.get(endpoints.get('publicProvinces'))
  },
  schoolsPerProvince(provinceId: string): Promise<AxiosResponse<TODO>> {
    return http.get(endpoints.get('publicSchoolsPerProvince', { provinceId }))
  },
  consent(consentFormName: string): Promise<AxiosResponse<TODO>> {
    return http.get(endpoints.get('consent', { consentFormName }))
  },
  document(type: string, isPublic = false, editionName?: string): Promise<AxiosResponse<TODO>> {
    const endpointLabel = isPublic ? 'publicResourceDocument' : 'resourceDocument'
    return http.get(endpoints.get(endpointLabel, { documentType: type, editionName }))
  },
  permissionedProvinces(): Promise<AxiosResponse<TODO>> {
    return http.get(endpoints.get('provinces'))
  },
  permissionedSchoolsPerProvince(provinceId: string): Promise<AxiosResponse<TODO>> {
    return http.get(endpoints.get('schoolsPerProvince', { provinceId }))
  },
  traditionalPaymentStatus(): Promise<AxiosResponse<TODO>> {
    return http.get(endpoints.get('traditionalPaymentStatus'))
  },
  excludeChildReasons(): Promise<AxiosResponse<ExclusionReasonResponse>> {
    return http.get(endpoints.get('excludeChildReasons'))
  },
  successCard(editionName: string): Promise<AxiosResponse<TODO>> {
    return http.get(endpoints.get('resourceSuccessCard', { editionName }))
  },
  donorContact(editionName: string): Promise<AxiosResponse<TODO>> {
    return http.get(endpoints.get('resourceDonorContact', { editionName }))
  },
  paymentListFilterData(): Promise<AxiosResponse<TODO>> {
    return http.get(endpoints.get('paymentListFilterData'))
  },
  childrenListFilterData(): Promise<AxiosResponse<TODO>> {
    return http.get(endpoints.get('childrenListFilterData'))
  },
  schoolsWithProvinceFilterData(): Promise<AxiosResponse<TODO>> {
    return http.get(endpoints.get('schoolsWithProvinceFilterData'))
  }
}
